export default __webpack_public_path__ + "static/media/ic_mood_bad_48px.160d5e85.svg";